import apiClient from '../utils/apiClient';

export const dashboardService = {
  // Get executive snapshot metrics
  async getExecutiveSnapshot() {
    const response = await apiClient.get('/api/dashboard/snapshot');
    return response.data;
  },

  // Get resource heatmap data
  async getResourceHeatmap(days = 7) {
    const response = await apiClient.get(`/api/dashboard/heatmap?days=${days}`);
    return response.data;
  },

  // Get attention required alerts
  async getAttentionRequired() {
    const response = await apiClient.get('/api/dashboard/attention');
    return response.data;
  },

  // Get project status overview
  async getProjectStatusOverview() {
    const response = await apiClient.get('/api/dashboard/projects/overview');
    return response.data;
  },

  // Get team availability
  async getTeamAvailability() {
    const response = await apiClient.get('/api/dashboard/team/availability');
    return response.data;
  },

  // Get personal dashboard data
  async getPersonalDashboard() {
    const response = await apiClient.get('/api/dashboard/personal');
    return response.data;
  }
};
